import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const ServiceCategory = ({ category, isActive, onClick, index }) => {
  return (
    <motion.button
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      onClick={() => onClick(category?.id)}
      className={`flex items-center space-x-3 px-4 sm:px-5 py-3 sm:py-4 rounded-xl border transition-all duration-300 w-full sm:flex-1 ${
        isActive
          ? 'bg-primary text-primary-foreground border-primary shadow-elevation-2'
          : 'bg-card text-foreground border-border hover:border-primary hover:shadow-elevation-1'
      }`}
    >
      <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center transition-all duration-300 flex-shrink-0 ${
        isActive ? 'bg-primary-foreground/20' : 'bg-muted'
      }`}>
        <Icon 
          name={category?.icon} 
          size={20} 
          color={isActive ? 'currentColor' : 'var(--color-muted-foreground)'}
        />
      </div>
      <div className="text-left flex-1 min-w-0">
        <div className="font-semibold text-sm">{category?.name}</div>
        <div className={`text-xs ${isActive ? 'text-primary-foreground/80' : 'text-muted-foreground'}`}>
          {category?.count} services
        </div>
      </div>
    </motion.button>
  );
};

export default ServiceCategory;